import { Component } from "react";
import {
  DataGrid as DevextremeDataGrid,
  IDataGridOptions,
  Pager,
} from "devextreme-react/data-grid";
import { IPagingProps } from "devextreme-react/data-grid";
import { IPagerProps } from "devextreme-react/data-grid";
import { Paging } from "devextreme-react/data-grid";
import { getFormattedNumber } from "shared/utility/NumberUtility";

export interface DataGridType extends DevextremeDataGrid {}

export interface GridPagerOptions {
  pagingOption?: IPagingProps;
  pagerOption?: IPagerProps;
}

export interface GridOptions {
  dataGridOptions: IDataGridOptions;
  classNames?: string;
  gridRef?: React.LegacyRef<DataGridType>;
  noDataText?: string;
  enablePagination?: boolean;
  paginationOptions?: GridPagerOptions;
}

const defaultPaginationOptions: GridPagerOptions = {
  pagerOption: {
    visible: true,
    showNavigationButtons: true,
    displayMode: "full",
  },
  pagingOption: {
    defaultPageSize: 8,
  },
};

export default class PromineoBaseDataGrid extends Component<GridOptions> {
  constructor(props: GridOptions) {
    super(props);
    this.state = {};
  }

  pagerOptions =
    this.props.paginationOptions?.pagerOption ??
    defaultPaginationOptions.pagerOption;

  pagingOptions =
    this.props.paginationOptions?.pagingOption ??
    defaultPaginationOptions.pagingOption;

  findFieldDataTypeFromDatasource = (dataField: string) => {
    const dataSource = this.props.dataGridOptions?.dataSource as Array<any>;
    var item = dataSource.find(
      (dsItem: any) => typeof dsItem[dataField] != "undefined"
    );

    if (item) {
      return typeof item[dataField];
    }

    return "undefined";
  };

  checkIfDataTypeIsNumberType = (type: any) => {
    return type === "number" || type === "bigint";
  };

  applyDefaultNumberFormatting = (columns: any) => {
    const dataSource = this.props.dataGridOptions?.dataSource as Array<any>;
    if (dataSource && dataSource.length) {
      columns.forEach((column: any) => {
        const columnDataField = column.dataField;
        let columnType = typeof dataSource[0][columnDataField];
        // Expected column and its dataType can be missing on specific datasource item as column can be undefined.
        // If it is not available in first datasource item(undefined), we need to find in other datasource item.
        if (columnType === "undefined") {
          columnType = this.findFieldDataTypeFromDatasource(columnDataField);
        }

        if (!column.format && this.checkIfDataTypeIsNumberType(columnType)) {
          column.format = getFormattedNumber;
        }
      });
    }
  };

  handleCustomizeColumn = (columns: any) => {
    this.applyDefaultNumberFormatting(columns);

    // Call child component's customizeColumns handle.
    const { customizeColumns: cildCustomizeColumns } =
      this.props.dataGridOptions;
    if (cildCustomizeColumns) {
      cildCustomizeColumns(columns);
    }
  };

  render() {
    const { children, gridRef, dataGridOptions } = this.props;

    return (
      <DevextremeDataGrid
        className={`promineo-base-datagrid ${this.props.classNames ?? ""}`}
        ref={gridRef}
        {...dataGridOptions}
        customizeColumns={this.handleCustomizeColumn}
      >
        {this.props.enablePagination && <Paging {...this.pagingOptions} />}
        {this.props.enablePagination && <Pager {...this.pagerOptions} />}
        {children}
      </DevextremeDataGrid>
    );
  }
}
